import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import pushData, { pushDataModel, pushDataRDO } from '../../actionCreators/pushData'
import RDOButton from './rdo/RDOButton'
import dismissModal from '../../actionCreators/dismissModal'
import i18n from 'live/services/i18n'
import styled from 'styled-components'

interface Props {
    perspective: number
    header: object[]
    sheetName: string
    databaseName: string
    sheetIndex: number
    eventType: string
    dateReference: boolean
    skipRealtime:boolean
    fileName: string
    isModel: boolean
    history: object
    showErrorModal: boolean
    error: object
    importing: boolean
    importedSuccessfully: boolean
    handleHideAndClose: () => void
    children: JSX.Element | JSX.Element[]
    dismissModal: () => void
    pushDataRDO: () => void
    pushDataModel: (sheetIndex: Number, eventType: string, keys: any[], perspective: Number, databaseName: string, dateReference: boolean,skipRealtime:boolean) => void
    sheet?: Sheet
}
interface Sheet {
    saveModelStatus: {
        status: number,
        msg: string
    }
}

function SubmitForm({ perspective,
    header,
    sheetName,
    sheet,
    databaseName,
    sheetIndex,
    eventType,
    dateReference,
    skipRealtime,
    fileName,
    isModel,
    history,
    showErrorModal,
    error,
    importing,
    importedSuccessfully,
    handleHideAndClose,
    children,
    dismissModal,
    pushDataRDO,
    pushDataModel
}: React.PropsWithChildren<Props>) {

    const [showKeysModal, setShowKeysModal] = useState<boolean>(false)
    const [showLoadingModal, setShowLoadingModal] = useState<boolean>(false)
    const [showOkModal, setShowOkModal] = useState<boolean>(false)
    const [keys, setKeys] = useState(header.filter(cell => cell.isKey).map(cell => cell.alias))
    const [keysCopy, setKeysCopy] = useState(null)
    const [eventTypeError, setEventTypeError] = useState(null)
    const [checkDatasource, setCheckDatasource] = useState<String>('')
    const { saveModelStatus } = sheet
    useEffect(() => {
        setKeys(header.filter(cell => cell.isKey).map(cell => cell.alias))
    }, [header])

    useEffect(() => {
        if (importing) {
            setShowLoadingModal(true)
        }
        if (importedSuccessfully) {
            setShowLoadingModal(false)
            setShowOkModal(false)
        }
    }, [importing, importedSuccessfully])
    
    useEffect(() => {        
        if(saveModelStatus?.status == 200){
            handleHideAndClose()
        }
    },[saveModelStatus?.status])

    const saveModel = () => {
        if (!databaseName || databaseName.length === 0) {
            setCheckDatasource("Invalid database name")
        } else if (!/^([a-z]\w*)$/.test(eventType)) {
            setCheckDatasource("Use only letters 'a' to 'Z', digits 0-9 and underscore _")
        } else {
            pushDataModel(
                sheetIndex,
                eventType,
                keys,
                perspective,
                databaseName,
                dateReference,
                skipRealtime
            )
        }
    }
    
    const handleSave = async () => {
         saveModel()        
    }
    
    const submitRDO = () => {
        //TODO FAZER TRAMTAMENTO DE CHAVES PARA RDO
        // if (this.state.keys.length > 0) {
        // this.setState(prevState => ({ showKeysModal: true, keysCopy: prevState.keys }))
        // } else {
        pushDataRDO(sheetIndex, 'rdo', keys, fileName)
        setEventTypeError(null)
        // }
    }

    const msgError =  saveModelStatus?.msg || checkDatasource

    return (
        <div className="import-form">
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    borderBottom: 'solid 2px #DDDEE1'
                }}
            >
                {children}
            </div>

            <StyledButtons>
                <button
                    className={`save${eventType === '' ? '--disabled' : ''}`}
                    data-cy="save-preview"
                    disabled={eventType === ''}
                    onClick={() => {
                        handleSave()
                    }}
                >
                    {i18n('Save')}
                </button>

                <button
                    className="cancel"
                    onClick={() => {
                        handleHideAndClose()
                    }}
                >
                    {i18n('Cancel')}
                </button>

                <RDOButton submitRDO={submitRDO} />
            </StyledButtons>

            {msgError ? (
                <label style={{ color: 'red', display: 'block' }}> {msgError} </label>
            ) : null}
        </div>
    )

}

const mapStateToProps = ({ sheet }) => {
    const { saveModelStatus } = sheet
    return {
        sheet,
        saveModelStatus
    }
}

export default connect(mapStateToProps, {
    pushDataRDO,
    pushDataModel,
    dismissModal
})(SubmitForm)


const StyledButtons = styled.div`
    margin-top: 20px;
    .save{
        background: var(--blue-500);
        color:var(--gray-0);
        border-radius: 3px;
        font-size: 15px;
        font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
        padding: 8px 24px;
        border: none;
        line-height: 16px;
        margin-left: 16px;
        &--disabled{
            background: var(--blue-400);
            color:var(--blue-200);
            border-radius: 3px;
            font-size: 15px;
            font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
            padding: 8px 24px;
            border: none;
            line-height: 16px;
            margin-left: 16px;
            font-weight: 600;
        } 
    }
    .cancel{
        color:var(--gray-800);
        font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
        background: var(--gray-0);
        font-size: 15px;
        border: 1px solid var(--gray-300);
        border-radius: 3px;
        font-weight: 600;
        line-height: 16px;
        margin-left: 10px;
    }
`